import { useEffect, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useAppSelector } from "../../app/hooks";
import Select from "../../components/input/Select";
import { useAvailableTeachersQuery } from "./manageCourseApiSlice";

interface Props {
	updateSelectedTeacher: (id: string) => void;
	disableConfirm: (disable: boolean) => void;
}

export default function AddCoteacherForm(props: Props) {
	const course = useAppSelector((state) => state.user.course);

	const [selectedTeacher, setSelectedTeacher] = useState("");

	const availableTeachersResult = useAvailableTeachersQuery(course?.id ?? skipToken);
	const availableTeachers = availableTeachersResult.data;

	useEffect(() => {
		props.updateSelectedTeacher(selectedTeacher);
	}, [selectedTeacher]);

	useEffect(() => {
		if (availableTeachers && availableTeachers?.length > 0) {
			props.disableConfirm(false);
			setSelectedTeacher(availableTeachers[0].value.toString());
		} else {
			props.disableConfirm(true);
		}
	}, [availableTeachers]);

	return availableTeachers && availableTeachers.length > 0 ? (
		<Select
			value={selectedTeacher}
			setValue={(v) => setSelectedTeacher(v as string)}
			simpleListBoxId="teacherDropdown"
			options={availableTeachers}
			label="Name:"
			fieldClasses="pt-3"
			simpleListBoxClasses="w-full"
		/>
	) : (
		<p className="pt-2">There are no teachers available to add to the course.</p>
	);
}
